import api from './api';

const getEcgByID = async id => {
  const response = await api.get(`ecg/${id}`);
  return response.data;
};

export default getEcgByID;
